import { RouterItemType } from "@/app/module/router/index";
import { LayoutPageHardware } from "./layout/index";

export const routerPageHardware: RouterItemType = {
  path: "/hardware",
  authorize: true,
  element: <LayoutPageHardware />,
};
